import React, { useEffect, useState } from "react";
// import "./Einvoice.scss";
import { convertEinvoicePasswordToHash, convertPasswordToHash, formatDate } from "../../utils/commonFunctions";
import {
  CommonHeader,
  ErrorSuccessModal,
  Loader,
  TableHeader,
  TableLoader,
} from "../../components/commons";
import { EINVOICE_HEADERS } from "../../constant/invoiceListConst";
import EinvoiceTableData from "../../components/InvoiceGeneration/EinvoiceModal/EinvoiceTableData";
import { RedErrorIcon, Warning } from "../../assets/images";
import EinvoiceRevert, {
  REVERT_EINVOICE_OPTION,
} from "../../components/InvoiceGeneration/EinvoiceModal/EinvoiceRevert";
import { connect } from "react-redux";
import { RootState } from "../../redux/rootReducers";
import {
  getReviewEinvoiceDataAction,
  postCancelEinvoiceDataAction,
  postEinvoiceAuthenticationAction,
  postEinvoiceDataAction,
  resetEinvoiceError,
  resetEinvoiceReviewData,
  resetInvoiceGenerationError,
  resetInvoiceGenerationSuccess,
  resetRevenueInvoicesList,
  resetSingleInvoiceData,
  resetSingleInvoiceDetails,
  resetSuccess,
} from "../../redux/invoiceGeneration";
import {
  AuthorizationType,
  EinvoiceAuthenticationDataPayloadType,
  EinvoiceDataPayloadType,
  EinvoiceRevertDataPayloadType,
} from "../../commonTypes/invoiceGenerationTypes";
import { resetSession } from "../../redux/auth";
import { EinvoiceReviewDataType } from "../../redux/invoiceGeneration/invoiceGenrationTypes";
import { LoginResponseType } from "../../redux/auth/authTypes";
import { UserIcon } from "../../components/Icon";
import { useMenuCheck } from "../../customHooks/useMenuCheck";
import InfiniteLoader from "../../components/commons/InfiniteLoader/InfiniteLoader";
import AuthorizationModal from "../../components/InvoiceGeneration/AuthorizationModal/AuthorizationModal";
import toast, { Toaster } from "react-hot-toast";
import { GetGenerateSasTokenPayloadType } from "../../commonTypes/stcoToolsType";
import { getTokenGenerateForDownloadAction, resetSasTokenForDownloadFile } from "../../redux/stcoTools";

type AppProps = {
  token: string | null;
  history: any;
  message: string | null;
  fetching: boolean;
  pdfFetching: boolean;
  success: number | null;
  error: string | null;
  statusCode: number | null;
  eInvoiceError: [];
  eInvoiceReviewData: EinvoiceReviewDataType | any;
  dispatchResetInvoiceGenerationErrorAction: () => void;
  dispatchPostEinvoiceDataAction: (data: EinvoiceDataPayloadType) => void;
  dispatchPostAuthenicateEinvoiceDataAction: (
    data: EinvoiceAuthenticationDataPayloadType
  ) => void;
  dispatchPostCancelEinvoiceDataAction: (
    data: EinvoiceRevertDataPayloadType
  ) => void;
  dispatchResetMessageAndSuccess: () => void;
  dispatchResetPreviewEinvoiceData: () => void;
  dispatchResetSession: () => void;
  dispatchResetSingleInvoiceDetails: () => void | null;
  dispatchResetEinvoiceError: () => void;
   dispatchGetTokenGenerateForDownloadAction:(data:GetGenerateSasTokenPayloadType)=>void;
    dispatchResetSasTokenForDownloadFile:()=>void;
    sasTokenForDownloadFile:string;
};

const EinvoiceModal = ({
  token,
  history,
  message,
  fetching,
  success,
  error,
  statusCode,
  eInvoiceError,
  eInvoiceReviewData,
  dispatchResetInvoiceGenerationErrorAction,
  dispatchPostEinvoiceDataAction,
  dispatchPostCancelEinvoiceDataAction,
  dispatchResetMessageAndSuccess,
  dispatchResetSession,
  dispatchPostAuthenicateEinvoiceDataAction,
  dispatchGetTokenGenerateForDownloadAction,
  dispatchResetSasTokenForDownloadFile,
  sasTokenForDownloadFile,
}: AppProps) => {
  const [eInvoiceAt, setEinvoiceAt] = useState(null);
  const [isEinvoicePresent, setIsEinvoicePresent] = useState<number>(0);
  const [cancelComment, setCancelComment] = useState("");
  const [isCancelEInvoicePresent, setIsCancelEInvoicePresent] = useMenuCheck();
  const [isGenerateEInvoicePresent, setIsGenerateEInvoicePresent] =
    useMenuCheck();
  const [isPreviewEInvoicePresent, setIsPreviewEInvoicePresent] =
    useMenuCheck();
  const [eInvoiceRadioValue, setEinvoiceRadioValue] = useState<string>(
    REVERT_EINVOICE_OPTION[0]?.id
  );
  const [isAuthorized, setIsAuthorized] = useState<boolean>(false);
  const [data, setData] = useState<AuthorizationType>({
    userName: "",
    password: "",
  });

  const company_name =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.company_name
      ? history.location.state.company_name
      : "";

  const client_code =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.client_code
      ? history.location.state.client_code
      : "";

  const invoiceId =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.invoiceId
      ? history.location.state.invoiceId
      : "";

  const eInvoiceStatus =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.eInvoiceStatus
      ? history.location.state.eInvoiceStatus
      : "";

  const eInvoiceTime =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.eInvoiceAt
      ? history.location.state.eInvoiceAt
      : "";

  useEffect(() => {
    setCancelComment("");
    setEinvoiceRadioValue(REVERT_EINVOICE_OPTION[0]?.id);
    setIsCancelEInvoicePresent("Cancel E-invoice", "menu");
    setIsGenerateEInvoicePresent("Generate E-invoice", "menu");
    setIsPreviewEInvoicePresent("Review E-invoice", "menu");
    setIsEinvoicePresent(eInvoiceStatus);
    setEinvoiceAt(eInvoiceTime);
    dispatchResetSasTokenForDownloadFile()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const downloadBlobFile = async (fileName: string) => {
    let finalData = {
      fileUrl: fileName,
      token,
      containerType:3

    };
    dispatchGetTokenGenerateForDownloadAction(finalData);
  };


   useEffect(() => {
      if (sasTokenForDownloadFile) {
        const link = document.createElement("a");
        link.href = sasTokenForDownloadFile;
        link.setAttribute("download", "");
        document.body.appendChild(link);
        link.click();
  
        document.body.removeChild(link);
        dispatchResetSasTokenForDownloadFile();
      }
    }, [sasTokenForDownloadFile]);


  useEffect(() => {
    if (error?.includes("Please Authenticate the User")) {
      return toggleAuthorization();
    }else if(error?.includes("Error in authenticating user!")){
      toast.error("Error in authenticating user!", {
        duration: 3000,
      });
      dispatchResetMessageAndSuccess();
      dispatchResetInvoiceGenerationErrorAction();
    }
    else if(error?.includes("E-invoicing authentication unsuccessfull")){
      toast.error("Either Username, Password or GSTIN is Wrong!", {
        duration: 3000,
      });
      dispatchResetMessageAndSuccess();
      dispatchResetInvoiceGenerationErrorAction();
    }
  }, [error]);

  useEffect(() => {
    if (message?.includes("Authentication successfull") && success === 1) {
      toast.success("Authentication successfull !", {
        duration: 3000,
      });
      toggleAuthorization();
      dispatchResetMessageAndSuccess();
      dispatchResetInvoiceGenerationErrorAction();
      setData({
        ...data,
        userName: "",
        password: "",
      });
    }
  }, [message, success]);

  const changeHeaders = (name: string) => {
    switch (name) {
      case "total_assessable_value":
        return "Total Assessable";
      case "total_cgst_value":
        return "Total CGST";
      case "total_sgst_value":
        return "Total SGST";
      case "total_igst_value":
        return "Total IGST";
      case "total_discount":
        return "Total Discount";
      case "total_invoice_value":
        return "Total Invoice";
      case "number_of_item":
        return "Number of Item";
      case "document_type":
        return "Document Type";
      case "document_number":
        return "Document Number";
      case "document_date":
        return "Document Date";
      case "address1":
        return "Address 1";
      case "address2":
        return "Address 2";
      case "legal_name":
        return "Legal Name";
      case "trade_name":
        return "Trade Name";
      case "location":
        return "Location";
      case "pincode":
        return "Pin Code";
      case "gstin":
        return "GSTIN";
      case "state_code":
        return "State Code";
      case "email":
        return "Email";
      case "phone_number":
        return "Phone Number";
      case "item_serial_number":
        return "Serial No.";
      case "product_description":
        return "Product Description";
      case "unit":
        return "Unit";
      case "place_of_supply":
        return "Place of Supply";
      case "quantity":
        return "Quantity";
      case "hsn_code":
        return "Hsn Code";
      case "discount":
        return "Discount";
      case "unit_price":
        return "Unit Price";
      case "total_amount":
        return "Total Amount";
      case "assessable_value":
        return "Assessable Value";
      case "gst_rate":
        return "Gst Rate";
      case "igst_amount":
        return "IGST Amount";
      case "sgst_amount":
        return "SGST Amount";
      case "cgst_amount":
        return "CGST Amount";
      case "total_item_value":
        return "Total Item Value";
      case "is_service":
        return "Service";

      default:
        return name;
    }
  };

  const createRows = (data: any, obj: any) => {
    let rowCreated = data?.map((item: any) => {
      return (
        <div className="one-input">
          <div className="inside-row-e-invoice">{changeHeaders(item)}</div>
          <div className="row-einvoice">
            {obj[item]
              ? item === "document_date"
                ? formatDate(obj[item])
                : obj[item]
              : "--"}
          </div>
        </div>
      );
    });
    return rowCreated;
  };

  const toggleAuthorization = () => {
    dispatchResetMessageAndSuccess()
    dispatchResetInvoiceGenerationErrorAction()
    setIsAuthorized((prev) => !prev);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setData({ ...data, [event.target.name]: event.target.value });
  };

  const handleSubmitAuthenication = async () => {
    let finalPassword = await convertEinvoicePasswordToHash(data.password);
    if (token) {
      let finalData = {
        userName: data?.userName,
        password: finalPassword,
        token,
        gstin: eInvoiceReviewData?.seller_details?.gstin,
        clientCode: client_code,
      };
      dispatchPostAuthenicateEinvoiceDataAction(finalData);
    }
  };

  const handleSubmitPreviewEinvoice = (type: string) => {
    if (type === "submit") {
      let payload = {
        client_code,
        token,
        invoice_id: +invoiceId,
      };
      dispatchPostEinvoiceDataAction(payload);
    } else if (type == "revert") {
      let payload = {
        client_code,
        token,
        invoice_id: +invoiceId,
        cancel_reason: eInvoiceRadioValue,
        cancel_remarks: cancelComment,
      };
      dispatchPostCancelEinvoiceDataAction(payload);
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        if (error?.includes("Please Authenticate the User") || error?.includes("Error in authenticating user!") || error?.includes("E-invoicing authentication unsuccessfull")) {
          return;
        }
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title={"Error"}
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetInvoiceGenerationErrorAction();
              dispatchResetMessageAndSuccess();
            }}
          />
        );
      }
    } else {
      if (
        success === 1 &&
        !!message &&
        (message === "E-invoicing created successfully" ||
          message === "E-invoice has been cancelled successfully.")
      ) {
        return (
          <ErrorSuccessModal
            type="success"
            isOpen={success === 1}
            title="Success"
            message={
              message === "E-invoicing created successfully"
                ? "E-Invoicing Created Successfully!"
                : message === "E-invoice has been cancelled successfully."
                ? "E-Invoicing Cancelled Successfully!"
                : null
            }
            buttonText="OK"
            onPress={() => {
              dispatchResetMessageAndSuccess();
              dispatchResetInvoiceGenerationErrorAction();
              history.goBack();
            }}
            statusCode={statusCode}
          />
        );
      }
    }

    return false;
  };

  const EinvoiceModalBody = () => {
    return eInvoiceReviewData?.id ? (
      <div className="e-invoice">
       
        <div
          className={
            isEinvoicePresent === 1 ||
            isEinvoicePresent === 2 ||
            eInvoiceError?.length
              ? "reverse-einvoice"
              : ""
          }
        >
          {/* left side preview  */}

          <div
            style={
              isEinvoicePresent === 1 ||
              isEinvoicePresent === 2 ||
              eInvoiceError?.length
                ? { width: "60%" }
                : {}
            }
          >
            {(isEinvoicePresent === 1 || isEinvoicePresent === 2) &&
            !!eInvoiceReviewData?.irn?.length ? (
              <div className="ml-4 mt-1 mb-1 irn">
                {" "}
                <span style={{ fontWeight: "500" }}>IRN NO </span> :{" "}
                {eInvoiceReviewData?.irn}
              </div>
            ) : null}

            {message ===
            "E-invoice review data fetched successfully. However, the PDF could not be downloaded." ? (
              <div className="alerts">
                <img width={"40px"} src={Warning} alt="warning" />
                E-invoice review data fetched successfully. However, the PDF
                could not be downloaded. If the issue perists please download it
                from E-invoice portal
              </div>
            ) : null}

            {/* value_details */}
            <div className={"sub-heading-e-invoice"}>VALUE DETAILS</div>

            {eInvoiceReviewData?.value_details ? (
              <div
                className={
                  isEinvoicePresent === 1 ||
                  isEinvoicePresent === 2 ||
                  eInvoiceError?.length
                    ? "inside-einvoice-reverse"
                    : "inside-einvoice"
                }
              >
                {createRows(
                  Object.keys(eInvoiceReviewData?.value_details),
                  eInvoiceReviewData?.value_details
                )}
              </div>
            ) : null}

            {/* document  */}
            <div className={"sub-heading-e-invoice"}>DOCUMENT DETAILS</div>
            {eInvoiceReviewData?.document_details ? (
              <div
                className={
                  isEinvoicePresent === 1 ||
                  isEinvoicePresent === 2 ||
                  eInvoiceError?.length
                    ? "inside-einvoice-reverse"
                    : "inside-einvoice"
                }
              >
                {createRows(
                  Object.keys(eInvoiceReviewData?.document_details),
                  eInvoiceReviewData?.document_details
                )}
              </div>
            ) : null}

            {/* buyer Details  */}
            <div className={"sub-heading-e-invoice"}>SELLER DETAILS</div>
            {eInvoiceReviewData?.seller_details ? (
              <div
                className={
                  isEinvoicePresent === 1 ||
                  isEinvoicePresent === 2 ||
                  eInvoiceError?.length
                    ? "inside-einvoice-reverse"
                    : "inside-einvoice"
                }
              >
                {createRows(
                  Object.keys(eInvoiceReviewData?.seller_details),
                  eInvoiceReviewData?.seller_details
                )}
              </div>
            ) : null}

            {/* seller Details  */}
            <div className={"sub-heading-e-invoice"}>BUYER DETAILS</div>
            {eInvoiceReviewData?.buyer_details ? (
              <div
                className={
                  isEinvoicePresent === 1 ||
                  isEinvoicePresent === 2 ||
                  eInvoiceError?.length
                    ? "inside-einvoice-reverse"
                    : "inside-einvoice"
                }
              >
                {createRows(
                  Object.keys(eInvoiceReviewData?.buyer_details),
                  eInvoiceReviewData?.buyer_details
                )}
              </div>
            ) : null}

            {/* item list  */}
            <div className={"sub-heading-e-invoice"}>ITEM DETAILS</div>
            {eInvoiceReviewData?.item_list?.length ? (
              <div
                className={"inside-einvoice-items"}
                style={{ overflowX: "scroll" }}
              >
                <table className="table thead-light table-bordered ml-4">
                  <thead className="text-left no-wrap sticky-table-header">
                    <TableHeader tableHeader={EINVOICE_HEADERS} />
                  </thead>
                  <tbody>
                    <EinvoiceTableData
                      tableHeaders={EINVOICE_HEADERS}
                      data={eInvoiceReviewData?.item_list}
                    />
                  </tbody>
                </table>
              </div>
            ) : null}
           {!eInvoiceStatus ?  <div className="important-msg">Note: UNIT and HSN Code are mandatory for generating e-invoice. Please ensure they are filled.</div> : null}
          </div>

          {/* comment box  */}
          {(isEinvoicePresent === 1 ||
            isEinvoicePresent === 2 ||
            eInvoiceError?.length) ? 
            <div
              style={
                isEinvoicePresent === 1 ||
                isEinvoicePresent === 2 ||
                eInvoiceError?.length
                  ? { width: "40%" }
                  : {}
              }
            >
              {eInvoiceError?.length ? (
                <div
                  className="p-2"
                  style={{ marginLeft: "40px", border: "1px solid #ba4916" }}
                >
                  {eInvoiceError?.map((item: any) => {
                    return (
                      <div className="mt-2 mb-2 error-msg">
                        <span className="mr-1">
                          <img src={RedErrorIcon} alt="error" />
                        </span>
                        <span className="ml-2">{item?.ErrorMessage}</span>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <EinvoiceRevert
                  data={eInvoiceReviewData}
                  eInvoiceAt={eInvoiceAt}
                  cancelComment={cancelComment}
                  radioValue={eInvoiceRadioValue}
                  isEinvoicePresent={isEinvoicePresent}
                  setCancelComment={setCancelComment}
                  setRadioValue={setEinvoiceRadioValue}
                />
              )}
            </div>
           : null}
        </div>
      </div>
    ) : (
      <TableLoader Rows={10} ColumnPerRow={5} />
    );
  };

  const handleButtonText=(text:string)=>{
    return <button
    onClick={() =>
      handleSubmitPreviewEinvoice(
        isEinvoicePresent === 1 ? "revert" : "submit"
      )
    }
    disabled={
      fetching ||
      ((isEinvoicePresent === 1 || isEinvoicePresent === 2) &&
        !cancelComment?.length)
    }
    className="btn btn-primary"
    style={{ color: "#FFFFFF", textTransform: "capitalize" }}
  >{text}</button>
  }

  return (
    <>
      <div className="col-md-12">
        <div className="col-md-4 mb-3">
          <CommonHeader
            title={
              eInvoiceError?.length ? "Errors In E-Invoice" : "View E-Invoice"
            }
          />

          <div className="d-flex align-items-center">
            {client_code ? (
              <>
                <UserIcon /> &nbsp;
                {!!company_name ? company_name : company_name}{" "}
                {"(" + client_code + ")"}
              </>
            ) : null}
          </div>
        </div>
      </div>

      <div className="card">
        <div className="col-md-12 d-flex align-items-center justify-content-end">
          <>
          {isEinvoicePresent === 1 &&
            (!!eInvoiceAt
              ? !(+new Date(eInvoiceAt)?.getTime() + 86400000 < +new Date())
              : true)
              ? isCancelEInvoicePresent
                ? handleButtonText("Cancel E-Invoice")
                : ""
              : isEinvoicePresent === 2 ||
                eInvoiceError?.length ||
                (!!eInvoiceAt &&
                  +new Date(eInvoiceAt)?.getTime() + 86400000 < +new Date())
              ? isGenerateEInvoicePresent
                ? handleButtonText("Send E-Invoice")
                : ""
              : isGenerateEInvoicePresent
              ? handleButtonText("Send E-Invoice")
              : ""}
          </>
         
            
        

          {!!eInvoiceReviewData?.invoice_pdf_url && (
          <div className="flex" style={{ alignItems: "flex-end" }}>
            {" "}
            <button
              className="btn btn-primary mb-2 ml-4"
              onClick={()=>downloadBlobFile(JSON.parse(JSON.stringify(eInvoiceReviewData?.invoice_pdf_url))?.file_url)}
            >
              Download E-invoice Pdf
            </button>
          </div>
        )}
        </div>

        {isAuthorized ? (
          <AuthorizationModal
            data={data}
            handleChange={handleChange}
            gstData={eInvoiceReviewData?.seller_details}
            isOpen={isAuthorized}
            type="eInvoice"
            toggleAuthorization={toggleAuthorization}
            handleSubmit={handleSubmitAuthenication}
          />
        ) : null}

        <>{EinvoiceModalBody()}</>
        {handleErrorModal()}
        <Toaster />
      </div>
      {fetching && <Loader />}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  loginData: state.auth.loginData,
  fetching: state.invoiceGeneration.fetching,
  pdfFetching: state.invoiceGeneration.pdfFetching,
  success: state.invoiceGeneration.success,
  statusCode: state.invoiceGeneration.statusCode,
  error: state.invoiceGeneration.error,
  message: state.invoiceGeneration.message,
  singleInvoiceDetails: state.invoiceGeneration.singleInvoiceDetails,
  eInvoiceReviewData:
    state.invoiceGeneration.eInvoiceReviewData ||
    ({} as EinvoiceReviewDataType),
  eInvoiceData: state.invoiceGeneration.eInvoiceData,
  sasTokenForDownloadFile: state.stcoTools.sasTokenForDownloadFile,
  eInvoiceError: state.invoiceGeneration.eInvoiceError,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetRevenueInvoicesListAction: () =>
    dispatch(resetRevenueInvoicesList()),
  dispatchResetSingleInvoiceDetails: () =>
    dispatch(resetSingleInvoiceDetails()),
  dispatchPostEinvoiceDataAction: (data: EinvoiceDataPayloadType) =>
    dispatch(postEinvoiceDataAction(data)),
  dispatchPostCancelEinvoiceDataAction: (data: EinvoiceRevertDataPayloadType) =>
    dispatch(postCancelEinvoiceDataAction(data)),
  dispatchPostAuthenicateEinvoiceDataAction: (
    data: EinvoiceAuthenticationDataPayloadType
  ) => dispatch(postEinvoiceAuthenticationAction(data)),
  dispatchResetPreviewEinvoiceData: () => dispatch(resetEinvoiceReviewData()),
  dispatchResetInvoiceGenerationErrorAction: () =>
    dispatch(resetInvoiceGenerationError()),
  dispatchResetMessageAndSuccess: () => dispatch(resetSuccess()),
  dispatchResetInvoiceGenerationSuccessAction: () =>
    dispatch(resetInvoiceGenerationSuccess()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetEinvoiceError: () => dispatch(resetEinvoiceError()),
   dispatchGetTokenGenerateForDownloadAction: (data: GetGenerateSasTokenPayloadType) =>
      dispatch(getTokenGenerateForDownloadAction(data)),
    dispatchResetSasTokenForDownloadFile: () =>
      dispatch(resetSasTokenForDownloadFile()),
});
export default connect(mapStateToProps, mapDispatchToProps)(EinvoiceModal);
